import { transport } from 'config/transport';

export function callApiGetListStudentsLackingInvoice(classId, yearMonth) {
    return transport.get(`/mamnon/classes/${classId}/students/lackingOfInvoice`, { params: { yearMonth } });
}
